import { BUTTONS_INFO, INPUT_VALIDATION } from "../CartConfigurationUtils";
import CustomInputField from "./CustomInputField";
import CustomToggleButtons from "./CustomToggleButtons";
import { useEffect, useRef, useState } from "react";
import { convertValuesToConfig_cartConfigurationNew, getAvalableBuckets, getInitialStateMissedItemBasket, getInitialStateOrderFulfillment, getInitialStateOrderingConditions } from "../CartConfigurationService";
import { Autocomplete, TextField } from "@mui/material";
import { useSelector } from "react-redux";
import store from "../../../../../../stateManagement/store";

interface Props{
    name:string,
    values:any,
    setValues: React.Dispatch<React.SetStateAction<any>>;
    extraValues:any,
    setExtraValues:React.Dispatch<React.SetStateAction<any>>;
}
const buttonsInfo=BUTTONS_INFO
const inputValidation=INPUT_VALIDATION
export const  CartOrderingCriteria=(props:Props)=>{
  const savedRole=useSelector(()=>store.getState().roleState.role)
     const inputValidation = INPUT_VALIDATION;
      const handleValueChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
      ) => {
        // ;
        const { name, value } = e.target;
        let newValues = { ...props.extraValues, [name]: value };
        if (name === "orderValidationType") {
          if (value.split(",").length === 2) {
            if (props.extraValues?.orderingCriteriaType?.split(",").length > 1) {
              newValues = {
            ...newValues,
            orderingCriteriaType: props.extraValues?.orderingCriteriaType?.split(",")[1],
          };
            }
          }
        }
        if (name === "orderingCriteriaType") {
          const orderingValidationTypeCriteriaCondition =
            value?.split(",").length === 3 ? value?.split(",")[2] : null;
           newValues = {
        ...newValues,
        orderingValidationTypeCriteriaCondition:
          orderingValidationTypeCriteriaCondition,
      };
        }
        props.setExtraValues(newValues);
        const val=convertValuesToConfig_cartConfigurationNew(newValues,props.values,savedRole?.id?.toLowerCase())
        props.setValues((prev:any)=>({...prev,...val}))
      };
      useEffect(()=>{
        const val=getInitialStateOrderingConditions(Object.values(props.values))
        props.setExtraValues((prev:any)=>({...prev,...val}))
      },[])
    return (
        <>
         <>
          <CustomToggleButtons
            title="Select the type of validation to be implemented while placing orders"
            handleToggleChangeEvent={handleValueChange}
            values={props.extraValues}
            buttonsInfo={BUTTONS_INFO.orderValidationType}
            popOverContent = {"If the ordering condition data is uploaded manually, it will overwrite the data entered below."}
            // vertical={true}
          />
          <CustomToggleButtons
            title="Select the criteria"
            handleToggleChangeEvent={handleValueChange}
            values={props.extraValues}
            buttonsInfo={
              props.extraValues?.orderValidationType?.split(",")?.length !== 2
                ? BUTTONS_INFO.orderingCriteriaType
                : BUTTONS_INFO.orderingCriteriaType.filter(
                    (criteria) => criteria.value?.split(",").length === 1
                  )
            }
            // vertical={true}
          />
          {props.extraValues?.orderValidationType
            ?.split(",")
            ?.reverse()
            .map((validationType: string) =>
              props.extraValues?.orderingCriteriaType
                ?.split(",")
                .map((criteriaType: string, index: number) => {
                  //only taking first 2 values because for both ( & or | ) case i am storing the value like ( value,quantity,& ) so it will have 3 values but i need only 2
                  if (index >= 2) return null;

                  const keyToStore = `${validationType}_${criteriaType}`;
                  const isMinValidation = validationType === "min";
                  const isValueCriteria = criteriaType === "value";

                  const label = `Enter default ${
                    isMinValidation ? "minimum" : "maximum"
                  } ${isValueCriteria ? "value" : "quantity"}:`;
                  const placeholder = `Default ${
                    isMinValidation ? "minimum" : "maximum"
                  } ${isValueCriteria ? "value" : "quantity"}`;

                  return (
                    <CustomInputField
                      key={keyToStore}
                      label={label}
                      type="number"
                      values={props.extraValues}
                      name={keyToStore}
                      inputValidation={inputValidation.minMaxValueQuanitity}
                      handleInputChange={handleValueChange}
                      isSaveAttempted={true}
                      placeholder={placeholder}
                    />
                  );
                })
            )}
        </>
        </>
    )
}
export const CartOrderFulfillmentType=(props:Props)=>{
    const savedRole=useSelector(()=>store.getState().roleState.role)
    const handleValueChange=(e:any)=>{
        const {name,value}=e.target
        props.setExtraValues({...props.extraValues,[name]:value})
         const val=convertValuesToConfig_cartConfigurationNew({...props.extraValues,[name]:value},props.values,savedRole?.id?.toLowerCase())
        props.setValues((prev:any)=>({...prev,...val}))
    }
    useEffect(()=>{
        const val=getInitialStateOrderFulfillment(Object.values(props.values))
        props.setExtraValues((prev:any)=>({...prev,...val}))
    },[])
    return(
        <>
                  <CustomToggleButtons
                    title="Select the input type of delivery date"
                    handleToggleChangeEvent={handleValueChange}
                    values={props.extraValues}
                    buttonsInfo={buttonsInfo.deliveryDateType}
                  />  
        </>
    )
}
export const CartOrderFulfillmentTime=(props:Props)=>{
    const [stateChange,setStateChange]=useState(false)
    const savedRole=useSelector(()=>store.getState().roleState.role)
    const handleValueChange=(e:any)=>{
        const {name,value}=e.target
         let newValues = { ...props.extraValues, [name]: value };
          const val=convertValuesToConfig_cartConfigurationNew(newValues,props.values,savedRole?.id?.toLowerCase())
        props.setValues((prev:any)=>({...prev,...val}))
       props.setExtraValues(newValues)
}
useEffect(()=>{
setStateChange((prev)=>!prev)
},[props.extraValues])
return (
    <>
    {props.extraValues?.deliveryDateType==="Number"?(
    <CustomInputField
              label="Number of days to display for the delivery:"
              type="number"
              values={props.extraValues}
              name="deliveryDateValueNumber"
              inputValidation={inputValidation.deliveryDateValue.number}
              handleInputChange={handleValueChange}
              isSaveAttempted={true}
              placeholder={"Number of days"}
            />
    ):(
           <CustomInputField
              label="Text to display for the delivery:"
              type="string"
              values={props.extraValues}
              name="deliveryDateValueText"
              inputValidation={inputValidation.deliveryDateValue.text}
              handleInputChange={handleValueChange}
              isSaveAttempted={true}
              placeholder={"Text to display"}
            />
    )
    }
    </>
)
}

export const CartMissedItemBasket=(props:Props)=>{
     const savedRole: any = useSelector(() => store.getState().roleState.role);
      const availableBuckets = useRef<{id:string,title:string}[]>([]);
      const [availableBucketsChange,setAvailableBucketsChange]=useState<boolean>(false);
     useEffect(()=>{
    const fetchBucket=async()=>{
    const buckets=await getAvalableBuckets()
    availableBuckets.current=buckets
    setAvailableBucketsChange((prev)=>!prev)
    }
    fetchBucket()
     },[]) 
     useEffect(()=>{
      const missedItem=getInitialStateMissedItemBasket(Object.values(props.values))
      props.setExtraValues((prev:any)=>({...prev,...missedItem}))
     },[])
      const handleValueChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    // ;
    const { name, value } = e.target;
    let newValues = { ...props.extraValues, [name]: value };
    
    if (name === "missedProductCarouselOption"){
      // if values's missedItemBasketId doesn't exist in the availableBuckets then set it to availableBuckets[0]?.id
      if (value === "Personalised Curated Basket" && !availableBuckets?.current?.some((bucket:any) => bucket?.id === newValues?.missedItemBasketId) && availableBuckets?.current?.length>0) {
        newValues = {
          ...newValues,
          missedItemBasketId: availableBuckets.current[0]?.id,
        };
      }
    }
    const val=convertValuesToConfig_cartConfigurationNew(newValues,props.values,savedRole?.id?.toLowerCase())
    props.setValues((prev:any)=>({...prev,...val}))
    props.setExtraValues(newValues)
  }
    const handleDropDownChange = (event: any, newValue: any) => {
    const newValues = { ...props.extraValues, missedItemBasketId: newValue.id };
    props.setExtraValues(newValues);
    const val=convertValuesToConfig_cartConfigurationNew(newValue,props.values,savedRole?.id?.toLowerCase())
    props.setValues((prev:any)=>({...prev,...val}))
  };
return(
    <>
              <CustomToggleButtons
                title="Add a missed product carousal on the cart page?"
                handleToggleChangeEvent={handleValueChange}
                values={props.extraValues}
                buttonsInfo={
                  savedRole.id === "retailer"
                    ? buttonsInfo.missedProductCarouselEnabledRetailer
                    : buttonsInfo.missedProductCarouselEnabledSalesRep
                }
              />
              {((savedRole.id === "retailer" &&
                props.extraValues.missedProductCarouselEnabledRetailer === "true") ||
                (savedRole.id === "salesrep" &&
                 props.extraValues.missedProductCarouselEnabledSalesRep === "true")) &&
                savedRole.id === "retailer" && (
                  <>
                    <CustomToggleButtons
                      title="Which SKU should be visible in the carousal?"
                      handleToggleChangeEvent={handleValueChange}
                      values={props.extraValues}
                      buttonsInfo={buttonsInfo.missedProductCarouselOptions}
                    />
                    {props.extraValues.missedProductCarouselOption ===
                      "Personalised Curated Basket" && (
                      //create a drop down of the available baskets
                      <Autocomplete
                        disableClearable
                        options={availableBuckets.current??[]}
                        getOptionLabel={(option) => option.title}
                        value={
                          availableBuckets?.current?.find(
                            (bucket:any) => bucket.id === props.extraValues.missedItemBasketId
                          ) || undefined
                        }
                        onChange={handleDropDownChange}
                        renderInput={(params) => (
                          <TextField
                            sx={{
                              "& .MuiInputBase-root": {
                                fontSize: "14px",
                              },
                              "& .MuiFormLabel-root": {
                                fontSize: "14px",
                                marginTop: "-4px",
                                "&.MuiInputLabel-shrink": {
                                  marginTop: "0",
                                },
                              },
                            }}
                            {...params}
                            label="Select basket"
                            variant="outlined"
                          />
                        )}
                        sx={{
                          "& .MuiAutocomplete-inputRoot": {
                            padding: "4px",
                          },
                          marginTop: "5px",
                          width: "250px",
                        }}
                      />
                    )}
                  </>
                )}
            </>
)
}